export const environment = {
  production: true,
  apiBaseUrl:'https://www.workplacesafetyplanbuilder.labour.gov.on.ca/api/',
  instrumentationKey: '51311220-8219-41b1-92e2-9ceb01ded560',
  gaTrackingId: 'G-NB3J34F4C1'
};
